import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';

import { AlarmTypeFailure, AlarmTypeRequest, AlarmTypeSuccess } from './actions';
import { AlarmTypeService } from './service';

@Injectable()
export class AlarmTypeEffects {
  private readonly actions$ = inject(Actions);
  private readonly alarmTypeService = inject(AlarmTypeService);

  alarmType$ = createEffect(() =>
    this.actions$.pipe(
      ofType(AlarmTypeRequest),
      switchMap(({ parameters }) =>
        this.alarmTypeService.alarmType(parameters).pipe(
          map(data => AlarmTypeSuccess({ data })),
          catchError(error => of(AlarmTypeFailure({ error })))
        )
      )
    )
  );

}
